var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{staticClass:"kvass-media-types-youtube-create-trigger",attrs:{"type":"button"}},[_c('span',[_vm._v("YouTube")]),_c('Icon',{staticClass:"ml-1",attrs:{"icon":['fab', 'youtube']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }